<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ایجاد گروه جدید </template>
    <BRow>
      <!-- Title -->
      <BCol cols="12" md="6">
        <BFormGroup label="عنوان گروه" label-for="title">
          <BFormInput
            :state="titleState"
            v-model="newPriceCategory.title"
            id="title"
            trim
            placeholder="برای مثال بحث آزاد"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ titleError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>
      <!-- Duration -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="مدت زمان هر جلسه (بین 10 تا 120 دقیقه)"
          label-for="duration"
        >
          <BFormInput
            :state="durationState"
            v-model.number="newPriceCategory.duration"
            id="duration"
            trim
            type="number"
            placeholder="40"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ durationError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>
      <!-- Min Duration -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="حداقل زمان رزرو برای این گروه بندی"
          label-for="minDuration"
        >
          <BFormInput
            v-model.number="newPriceCategory.minDuration"
            id="minDuration"
            trim
            type="number"
            placeholder="60"
          />
        </BFormGroup>
      </BCol>
      <!-- User Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه کاربر (تومان)"
          label-for="userPrice"
        >
          <BFormInput
            :state="userPriceState"
            v-model.number="newPriceCategory.userPrice"
            id="userPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ userPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>
      <!-- Master Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه استاد (تومان)"
          label-for="masterPrice"
        >
          <BFormInput
            :state="masterPriceState"
            v-model.number="newPriceCategory.masterPrice"
            id="masterPrice"
            trim
            type="number"
            placeholder="80000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ masterPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Vip User Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه VIP کاربر (تومان)"
          label-for="userVipPrice"
        >
          <BFormInput
            :state="userVipPriceState"
            v-model.number="newPriceCategory.vipUserBasePaymentPrice"
            id="userVipPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ userVipPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Vip Master Price -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="قیمت پایه برای هر جلسه VIP استاد (تومان)"
          label-for="masterVipPrice"
        >
          <BFormInput
            :state="masterVipPriceState"
            v-model.number="newPriceCategory.vipMasterBasePaymentPrice"
            id="masterVipPrice"
            trim
            type="number"
            placeholder="120000"
          />
          <BFormInvalidFeedback id="input-live-feedback">
            {{ masterVipPriceError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>

      <!-- Language Picker -->
      <BCol cols="12" md="6">
        <LanguagePicker @getLanguage="setLanguage"></LanguagePicker>
      </BCol>

      <!-- Shared Price Category Ids -->
      <BCol cols="12" md="6">
        <BFormGroup
          label="گروه‌بندی های مشترک در غیبت"
          label-for="sharedPriceCategories"
        >
          <PriceCategoryPicker
            id="sharedPriceCategories"
            :isMultiple="true"
            :isRenderingLabel="false"
            @getPriceCategory="setPriceCategoryIds"
          ></PriceCategoryPicker>
        </BFormGroup>
      </BCol>

      <!-- DSD-662	 -->
      <!-- DaysLimit -->
      <!-- <BCol cols="12" md="6">
        <DaysLimitPicker v-model="newPriceCategory.daysLimit"></DaysLimitPicker>
      </BCol> -->

      <!-- Description -->
      <BCol cols="12">
        <BFormGroup
          :state="descriptionState"
          label="توضیحات گروه"
          label-for="description"
        >
          <BFormTextarea
            :state="descriptionState"
            placeholder="توضیحات گروه‌بندی"
            id="description"
            trim
            v-model="newPriceCategory.description"
          ></BFormTextarea>
          <BFormInvalidFeedback id="input-live-feedback">
            {{ descriptionError }}
          </BFormInvalidFeedback>
        </BFormGroup>
      </BCol>
      <!-- Has Penalty -->
      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="newPriceCategory.hasPenalty"
          name="check-button"
          switch
        >
          <small style="margin-left: 3px">
            آیا این گروه‌بندی جریمه دارد؟
          </small>

          <b>({{ newPriceCategory.hasPenalty ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>

      <!-- isFreeFromLesson -->
      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="newPriceCategory.isFreeFromLesson"
          name="check-button"
          switch
        >
          <small style="margin-left: 3px">
            آیا این گروه‌بندی
            <b> بدون </b>
            درس خواهد بود؟
          </small>

          <b>({{ newPriceCategory.isFreeFromLesson ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>

      <!-- isPrivate -->

      <BCol cols="12" md="6">
        <BFormCheckbox
          v-model="newPriceCategory.isPrivate"
          name="check-button"
          switch
        >
          <small style="margin-left: 3px">
            آیا این گروه‌بندی خصوصی است؟
          </small>

          <b>({{ newPriceCategory.isPrivate ? "بله" : "خیر" }})</b>
        </BFormCheckbox>
      </BCol>
    </BRow>
    <BRow>
      <BCol cols="12" class="d-flex align-items-center justify-content-end">
        <BButton
          @click="sendNewPriceCategoryRequest"
          :disabled="isSubmitButtonDisabled"
          variant="success"
        >
          ثبت
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      newPriceCategory: {
        id: 0,
        langId: null,
        title: null,
        duration: 10,
        userPrice: null,
        masterPrice: null,
        hasPenalty: false,
        description: null,
        isFreeFromLesson: false,
        minDuration: null,
        vipMasterBasePaymentPrice: null,
        vipUserBasePaymentPrice: null,
        priceCategoryIds: [],
        daysLimit: null,
        isPrivate: null,
      },
    };
  },
  methods: {
    setDaysLimit(daysLimit) {
      this.newPriceCategory.daysLimit = daysLimit;
    },
    setPriceCategoryIds(priceCategoryIds) {
      this.newPriceCategory.priceCategoryIds = priceCategoryIds;
    },
    setLanguage(langId) {
      this.newPriceCategory.langId = langId;
    },
    async sendNewPriceCategoryRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let createNewPriceCategory = new CreateNewPriceCategory(_this);
        createNewPriceCategory.setRequestParamDataObj(_this.newPriceCategory);
        await createNewPriceCategory.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "گروه‌بندی با موفقیت ایجاد شد.",
              },
            });
            _this.newPriceCategory = {
              id: 0,
              langId: null,
              title: null,
              duration: 10,
              userPrice: null,
              masterPrice: null,
              hasPenalty: false,
              description: null,
              isFreeFromLesson: false,
              minDuration: null,
              vipMasterBasePaymentPrice: null,
              vipUserBasePaymentPrice: null,
              priceCategoryIds: [],
              isPrivate: false,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    // CreateNewPriceCategory
  },
  computed: {
    titleState() {
      if (
        this.newPriceCategory.title &&
        this.newPriceCategory.title.length <= 200
      ) {
        return true;
      } else if (
        (this.newPriceCategory.title &&
          this.newPriceCategory.title.length > 200) ||
        this.newPriceCategory.title == ""
      ) {
        return false;
      } else {
        return null;
      }
    },
    titleError() {
      if (
        this.newPriceCategory.title != null &&
        this.newPriceCategory.title == ""
      ) {
        return "فیلد عنوان نباید خالی باشد";
      } else if (
        this.newPriceCategory.title &&
        this.newPriceCategory.title.length > 200
      ) {
        return "متن عنوان نباید بیشتر از 200 کاراکتر باشد";
      }
    },

    durationState() {
      if (
        this.newPriceCategory.duration == "" ||
        this.newPriceCategory.duration < 10 ||
        this.newPriceCategory.duration > 120
      ) {
        return false;
      } else if (
        this.newPriceCategory.duration &&
        this.newPriceCategory.duration >= 10 &&
        this.newPriceCategory.duration <= 120
      ) {
        return true;
      } else {
        return null;
      }
    },
    durationError() {
      if (
        this.newPriceCategory.duration != null &&
        this.newPriceCategory.duration == ""
      ) {
        return "فیلد مدت زمان اجباری است";
      } else if (
        this.newPriceCategory.duration &&
        this.newPriceCategory.duration < 10
      ) {
        return "مدت زمان نباید کمتر از 10 دقیقه باشد";
      } else if (
        this.newPriceCategory.duration &&
        this.newPriceCategory.duration > 120
      ) {
        return "مدت زمان نباید بیشتر از 120 دقیقه باشد";
      }
    },

    userPriceState() {
      if (
        this.newPriceCategory.userPrice != null &&
        (this.newPriceCategory.userPrice == "" ||
          this.newPriceCategory.userPrice < 1000)
      ) {
        return false;
      } else if (
        this.newPriceCategory.userPrice &&
        this.newPriceCategory.userPrice >= 1000
      ) {
        return true;
      } else if (this.newPriceCategory.userPrice == null) {
        return null;
      }
    },
    userVipPriceState() {
      if (
        this.newPriceCategory.vipUserBasePaymentPrice &&
        this.newPriceCategory.vipUserBasePaymentPrice < 1000
      ) {
        return false;
      } else if (
        this.newPriceCategory.vipUserBasePaymentPrice &&
        this.newPriceCategory.vipUserBasePaymentPrice >= 1000
      ) {
        return true;
      } else if (this.newPriceCategory.vipUserBasePaymentPrice == null) {
        return null;
      }
    },

    userVipPriceError() {
      if (
        this.newPriceCategory.vipUserBasePaymentPrice &&
        this.newPriceCategory.vipUserBasePaymentPrice < 1000
      ) {
        return "قیمت پایه VIP زبان آموز نباید کمتر از 1000 تومان باشد";
      }
    },

    masterVipPriceState() {
      if (
        this.newPriceCategory.vipMasterBasePaymentPrice &&
        this.newPriceCategory.vipMasterBasePaymentPrice < 1000
      ) {
        return false;
      } else if (
        this.newPriceCategory.vipMasterBasePaymentPrice &&
        this.newPriceCategory.vipMasterBasePaymentPrice >= 1000
      ) {
        return true;
      } else if (this.newPriceCategory.vipMasterBasePaymentPrice == null) {
        return null;
      }
    },
    masterVipPriceError() {
      if (
        this.newPriceCategory.vipMasterBasePaymentPrice &&
        this.newPriceCategory.vipMasterBasePaymentPrice < 1000
      ) {
        return "قیمت پایه VIP استاد نباید کمتر از 1000 تومان باشد";
      }
    },

    userPriceError() {
      if (
        this.newPriceCategory.userPrice != null &&
        this.newPriceCategory.userPrice == ""
      ) {
        return "فیلد قیمت پایه زبان آموز اجباری است";
      } else if (
        this.newPriceCategory.userPrice &&
        this.newPriceCategory.userPrice < 1000
      ) {
        return "قیمت پایه زبان آموز نباید کمتر از 1000 تومان باشد";
      }
    },

    masterPriceState() {
      if (
        this.newPriceCategory.masterPrice != null &&
        (this.newPriceCategory.masterPrice == "" ||
          this.newPriceCategory.masterPrice < 1000)
      ) {
        return false;
      } else if (
        this.newPriceCategory.masterPrice &&
        this.newPriceCategory.masterPrice >= 1000
      ) {
        return true;
      } else if (this.newPriceCategory.masterPrice == null) {
        return null;
      }
    },
    masterPriceError() {
      if (
        this.newPriceCategory.masterPrice != null &&
        this.newPriceCategory.masterPrice == ""
      ) {
        return "فیلد قیمت پایه استاد اجباری است";
      } else if (
        this.newPriceCategory.masterPrice &&
        this.newPriceCategory.masterPrice < 1000
      ) {
        return "قیمت پایه استاد نباید کمتر از 1000 تومان باشد";
      }
    },

    descriptionState() {
      if (
        this.newPriceCategory.description != null &&
        (this.newPriceCategory.description == "" ||
          this.newPriceCategory.description.length > 4000)
      ) {
        return false;
      } else if (
        this.newPriceCategory.description &&
        this.newPriceCategory.description.length <= 4000
      ) {
        return true;
      } else if (this.newPriceCategory.description == null) {
        return null;
      }
    },
    descriptionError() {
      if (
        this.newPriceCategory.description != null &&
        this.newPriceCategory.description == ""
      ) {
        return "فیلد توضیحات گروه‌بندی اجباری است";
      } else if (
        this.newPriceCategory.description &&
        this.newPriceCategory.description.length > 4000
      ) {
        return "توضیحات گروه‌بندی نباید بیشتر از 4000 کاراکتر باشد";
      }
    },

    isSubmitButtonDisabled() {
      if (
        this.descriptionState &&
        this.masterPriceState &&
        this.userPriceState &&
        this.durationState &&
        this.titleState
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BOverlay,
    BInputGroup,
    BFormInvalidFeedback,
    LanguagePicker,
    PriceCategoryPicker,
    PageWrapper,
    DaysLimitPicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import DaysLimitPicker from "@/views/components/PriceCategory/DaysLimitPicker.vue";
import { CreateNewPriceCategory } from "@/libs/Api/PriceCategory";

import {
  BCard,
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BButton,
  BFormTextarea,
  BOverlay,
  BFormInvalidFeedback,
} from "bootstrap-vue";
</script>
